<template>
    <span class="switcher">
        <input type="checkbox" class="check" v-model="new_value" @change="change">
        <slot></slot>
    </span>

</template>

<script>
export default {
    name: "EditablePublish",
    props: {
        id: '',
        target:'',
        value: false,
    },
    data() {
        return {
            new_value: '',
            load:false,
        }
    },
    created() {
        this.new_value = this.value === "1"
    },
    methods: {
        reset_value() {
            this.new_value = this.value
        },
        change() {
            this.load = true;
            axios
                .post('/editable',{
                    id:this.id,
                    target:this.target,
                    value:this.new_value,
                })
                .then(response => {
                    window.location.reload();
                })
                .catch(error => {
                    console.error(error)
                })
        },
    }
}
</script>

<style scoped>

.switcher {
    display: flex;
    align-items: center;
    /*height: 25px;*/
    margin-right: 10px;
}

.check {
    position: relative;
    width: 50px;
    height: 20px;
    cursor: pointer;
    margin-left: 10px;
    margin-right: 10px;
}

.check:before {
    content: '';
    position: absolute;
    background: #d9534f;
    width: 50px;
    height: 20px;
    border-radius: 25px;
}

.check:checked:before {
    background: #5cb85c;
}

.check:after {
    content: '';
    position: absolute;
    left: 0;
    background: #ffffff;
    width: 25px;
    height: 20px;
    border-radius: 25px;
    transition: 0.25s;
    border: 2px solid #333333;
    box-sizing: border-box;
}

.check:checked:after {
    left: 25px;
    background: #ffffff;
    border: 2px solid #333333;
}
</style>
